document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".opening-hours-wrapper").forEach(wrapper => {
    const container = wrapper.querySelector(".opening-hours-container");
    const statusWrapper = container.querySelector(".opening-hours-status-wrapper");
    const scheduleElement = container.querySelector(".weekly-schedule");
    const holidayElement = container.querySelector(".holiday-message");
    const notesElement = container.querySelector(".additional-notes");
    const holidayHeadingLabel = container.dataset.holidayHeadingLabel;

    const spaId = container.dataset.spaId;
    const endpoint = container.dataset.endpoint;

    if (!spaId || !endpoint) return;

    const apiUrl = `${endpoint}/api/spas/${spaId}/opening-hours`;

    fetch(apiUrl)
      .then(response => {
        if (!response.ok) throw new Error("HTTP " + response.status);
        return response.json();
      })
      .then(data => {

        if (data && data.spa) {
          const spa = data.spa;
          const today = new Date(spa.currentTime || new Date());
          let statusClass = '';
          let statusText = '';
          const nextStatus = spa.nextStatus.charAt(0).toLowerCase() + spa.nextStatus.slice(1);

          if (spa.currentStatus && spa.currentStatus.toLowerCase().includes("open")) {
            if (spa.nextStatus && spa.nextStatus.toLowerCase().includes("closes")) {
              statusText = `<span><strong>${spa.currentStatus}</strong>, </span> ${nextStatus}`;
              statusClass = "open";
            }
          } else if (spa.currentStatus && spa.currentStatus.toLowerCase().includes("closed")) {
            if (spa.nextStatus && spa.nextStatus.toLowerCase().includes('opens')) {
              statusText = `<span><strong>${spa.currentStatus}</strong>, </span> ${nextStatus}`;
              statusClass = "closed";
            } else {
              statusText = `<span><strong>${spa.currentStatus}</strong></span>`;
              statusClass = "closed";
            }
          } else {
            statusText = `<span>Status unavailable </span>`;
            statusClass = "unavailable";
          }

          statusWrapper.innerHTML = `
            <span class="icon-content flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <g clip-path="url(#clip0_5092_121)">
                  <path d="M9.99996 19.2633C14.6023 19.2633 18.3333 15.5324 18.3333 10.93C18.3333 6.32764 14.6023 2.59668 9.99996 2.59668C5.39759 2.59668 1.66663 6.32764 1.66663 10.93C1.66663 15.5324 5.39759 19.2633 9.99996 19.2633Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M10 5.93018V10.9302L13.3333 12.5968" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
                <defs>
                  <clipPath id="clip0_5092_121">
                    <rect width="20" height="20" fill="white" transform="translate(0 0.930176)"></rect>
                  </clipPath>
                </defs>
              </svg>
              <span class="opening-hours-status ${statusClass}">${statusText}</span>
              <svg xmlns="http://www.w3.org/2000/svg" class="accordion-arrow" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path d="M4 6.93018L8 10.9302L12 6.93018" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>
          `;

          const holidayMap = {};
          if (spa.holidays && spa.holidays.length) {
            spa.holidays.forEach(hol => {
              if (hol.isInVisibilityWindow) {
                holidayMap[hol.date] = hol.name;
              }
            });
          }

          if (spa.openingHours && spa.openingHours.length) {
            const weekOrder = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
            const dayMap = {};
            spa.openingHours.forEach(h => (dayMap[h.day] = h));

            const headingElement = document.createElement("h3");
            headingElement.className = "opening-hours-heading";

            const list = document.createElement("ul");
            list.className = "opening-hours-list";

            weekOrder.forEach(dayName => {
              const h = dayMap[dayName];
              if (!h) return;

              const li = document.createElement("li");
              li.className = h.isToday ? "today" : "";
              let content = `<span class="day">${h.day}</span>`;
              const dayDate = h.date ? new Date(h.date) : null;

              const dateKey = h.date?.split("T")[0];
              const holidayName = holidayMap[dateKey];

              // If a holiday name exists, always display "CLOSED" and show the holiday name.
              if (holidayName) {
                content += `<span class="hours is-closed">CLOSED</span>`;
                content += `<span class="holiday">${holidayName}</span>`;
              }
              // If the day is marked as an exception
              else if (h.isException) {
                if (h.opens && h.closes) {
                  content += `<span class="hours">${h.opens} – ${h.closes}</span>`;
                  if (h.notes) content += `<span class="notes">${h.notes}</span>`;
                } else {
                  content += `<span class="hours is-closed">CLOSED</span>`;
                  if (h.notes) content += `<span class="notes">${h.notes}</span>`;
                }
              }
              // If status includes "open", display open–close hours
              else if (h.status && h.status?.toLowerCase().includes("open")) {
                if (h.opens && h.closes) {
                  content += `<span class="hours">${h.opens} – ${h.closes}</span>`;
                  if (h.notes) content += `<span class="notes">${h.notes}</span>`;
                } else {
                  content += `<span class="hours is-closed">CLOSED</span>`;
                  if (h.notes) content += `<span class="notes">${h.notes}</span>`;
                }
              }
              // If status includes "close", display "CLOSED"
              else if (h.status && h.status.toLowerCase().includes("close")) {
                content += `<span class="hours is-closed">CLOSED</span>`;
                if (h.notes) content += `<span class="notes">${h.notes}</span>`;
              }
              // All other normal days
              else {
                content += h.opens && h.closes
                  ? `<span class="hours">${h.opens} – ${h.closes}</span>`
                  : `<span class="hours is-closed">CLOSED</span>`;
                if (h.notes) content += `<span class="notes">${h.notes}</span>`;
              }

              li.innerHTML = content;
              list.appendChild(li);
            });

            scheduleElement.innerHTML = "";
            scheduleElement.appendChild(headingElement);
            scheduleElement.appendChild(list);
          }

          if (spa.holidays && spa.holidays.length) {
            const previewLimit = new Date(today);
            previewLimit.setDate(today.getDate() + 21);
            const weekDates = spa.openingHours?.map(h => h.date?.split("T")[0]) || [];

            const upcoming = spa.holidays.filter(hol => {
              const holDate = new Date(hol.date);
              return (
                hol.isInVisibilityWindow &&
                holDate >= today &&
                holDate <= previewLimit &&
                !weekDates.includes(hol.date)
              );
            });

            holidayElement.innerHTML = "";

            if (upcoming.length) {
              const holidayHeading = document.createElement("h4");
              holidayHeading.className = "holiday-heading";
              holidayHeading.textContent = holidayHeadingLabel;

              const holidayList = document.createElement("ul");
              holidayList.className = "holiday-preview-list";

              upcoming.forEach(hol => {
                const li = document.createElement("li");

                const nameSpan = document.createElement("span");
                nameSpan.className = "holiday-name";
                nameSpan.textContent = hol.name;

                const dateSpan = document.createElement("span");
                dateSpan.className = "holiday-date";
                const holDate = new Date(hol.date);
                const formattedDate = holDate.toLocaleDateString('en-GB', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric'
                });
                dateSpan.textContent = formattedDate;

                li.appendChild(nameSpan);
                li.appendChild(dateSpan);
                holidayList.appendChild(li);
              });

              holidayElement.appendChild(holidayHeading);
              holidayElement.appendChild(holidayList);
              holidayElement.style.display = "block";
            } else {
              holidayElement.style.display = "none";
            }
          } else {
            holidayElement.innerHTML = "";
            holidayElement.style.display = "none";
          }
        }
        else {
          statusWrapper.innerHTML = `<span class="opening-hours-status unavailable">No data available</span>`;
        }
      })
      .catch(err => {
        statusWrapper.innerHTML = `<span class="opening-hours-status unavailable">Hours unavailable</span>`;
      });
  });
});